import { Component } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { PulloutComponent } from '@gallaghercp/core-components/pullout';

@Component({
    selector: 'core-client-block-pullout',
    templateUrl: './block-pullout.component.html',
    imports: [PulloutComponent],
    styleUrl: './block-pullout.component.scss',
})
export class BlockPulloutComponent extends BlockAbstractComponent {
    showLinkAsEntireElement = false;

    override ngOnInit() {
        this.showLinkAsEntireElement = this.block.data.buttonVariant === 'Use entire pullout as link';
        if (this.showLinkAsEntireElement) {
            // Fallback to prevent link text from being empty
            this.block.data.ctaText = this.block.data.heading || 'Pullout link';
        }
        super.ngOnInit();
    }
}
